import { ThemeProvider } from "@emotion/react"
import { createTheme } from "@mui/material"
import CssBaseline from "@mui/material/CssBaseline"
import React, { Fragment, Suspense } from "react"
import { RouterProvider } from "react-router-dom"
import { Bounce, ToastContainer } from "react-toastify"
import { FeedbackModal, StripePaymentModal } from "../components/modals"
import PlanUpdateModal from "../components/modals/planUpdateModal"
import { FullScreenLoader } from "../components/ui/fullScreenLoader"
import {
  useFirebaseAuth,
  useStripeReturnDetection,
  useUsageDetails,
} from "../hooks"
import { useAppSelector } from "../redux"
import { initializeMixpanel, initializeSentry } from "../utils"
import { router } from "./routes/router"
import { getTheme } from "./theme"

initializeSentry()
initializeMixpanel()

function App() {
  const [loading] = useFirebaseAuth()
  useUsageDetails()
  useStripeReturnDetection()

  const theme = createTheme(getTheme)
  const user = useAppSelector((state) => state.app.user)

  if (loading) {
    return <FullScreenLoader />
  }

  return (
    <Fragment>
      <ThemeProvider theme={theme}>
        <CssBaseline enableColorScheme />
        <Suspense fallback={<FullScreenLoader />}>
          <RouterProvider router={router} />
        </Suspense>
        <ToastContainer
          position="bottom-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="dark"
          transition={Bounce}
        />
      </ThemeProvider>
      {user && <StripePaymentModal />}
      {user && <PlanUpdateModal />}
      <FeedbackModal />
    </Fragment>
  )
}

export default App
